import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { folioHistoryList, folioDetailsApi } from '../Controller/BookingController';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker'
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary'
import ModalGlobal from '../../../../Utility/Components/ModalGlobal'
import Utility from '../../../../Utility/Utility'
import CustomButton from '../../../../Utility/Components/CustomButton';
import PaymentViewModalContent from '../../Home/Components/PaymentViewModalContent';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

function FolioDetails(props) {
    const [hasMoreFolioList, setHasMoreFolioList] = useState(true)
    const [viewDetailsData, setViewDetailsData] = useState([])
    const [paymentViewDetails, setPaymentViewDetails] = useState([])
    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [paymentHistoryShowFlag, setPaymentHistoryShowFlag] = useState(false);
    const [bookingStatus, setBookingStatus] = useState('');
    const [userDetailsData, setUserDetailsData] = useState({})
    const [selectedFolioDetails, setSelectedFolioDetails] = useState([]);
    const [paymentDetailsModalFlag, setPaymentDetailsModalFlag] = useState(false);
    const [sourcingBookingId, setSourcingBookingId] = useState("");
    const [actionDone, setActionDone] = useState(false);

    // console.log("props==", props.folioId)
  useEffect(() => {
    if (!props.isLoggedIn) {
      history.push(`/${localStorage.getItem('i18nextLng')}/login`);
    } 
  }, [props.isLoggedIn]);
    //booking details view fn
    const folioDetails = (folioId) => {
       
        const { loaderStateTrue, loaderStateFalse } = props;
        let filters = {};
        let globalQueryParamshash = {};
        // globalQueryParamshash["offset"] = startRow;
        // globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);
        if (Object.keys(globalQueryParamshash).length > 0) {
            filters['filters'] = JSON.stringify(globalQueryParamshash);
        }
        // console.log("filters========", filters)
        folioDetailsApi(folioId, filters).then((response) => {
            if (response.success) {
                // console.log("response.data.booking_details", response.data.booking_details)
                setViewDetailsData(response.data.booking_details)
                setSourcingBookingId(response.data?.folio_details?.booking_id)
            } else {
                console.error(error);
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
            }
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
    }

    // after set booking id , booking id get api call hits
    useEffect(() => {
        if (props.folioId) {
            // viewBookingDetailsFn(viewFolioId, "")
            folioDetails(props.folioId)
        }
    }, [props.folioId])

    const hotelFolioDataUi = () => {
        if (viewDetailsData.length === 0) {
            return (
                <div className='noDataFound'>
                    <h3 className='title'>No Data Found.</h3>
                </div>
            );
        }

        return (
            <div className="folio-table-container ">
                <table className="folio-table table table-hover">
                    <thead>
                        <tr style={{ backgroundColor: '#f8f9fa'}}>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Source Folio Number</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Customer name</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Email</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Transfer date</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Phone number</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Total amount</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Paid amount</th>
                            <th style={{ fontSize: '14px', color: '#525252', fontFamily: 'Poppins-Regular' }}>Due amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {viewDetailsData.map((folioObj, idx) => {
                            const formattedDate = folioObj.transfer_date ? moment(folioObj.transfer_date).format("DD-MM-YYYY") : 'N/A';
                            
                            return (
                                <tr key={idx}>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{folioObj.folio_number ?? 'N/A'}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{folioObj.customer_name ?? 'N/A'}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{folioObj.customer_email ?? 'N/A'}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{formattedDate}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{folioObj.customer_phone ?? 'N/A'}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{Utility.getCurrencySymbol('INR')}{folioObj.folio_amount ?? 0}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{Utility.getCurrencySymbol('INR')}{folioObj.cr_amount ?? 0}</td>
                                    <td style={{ fontSize: '13px', fontFamily: 'Poppins-Light', color: '#5f5f5f' }}>{Utility.getCurrencySymbol('INR')}{folioObj.due_amount ?? 0}</td>
                                    <td>
                                        {/* <CustomButton
                                            label="Payments"
                                            onClick={() => makePayment(folioObj)}
                                        /> */}
                                        <button type="button" className="modbtn"
                                            onClick={(e) => makePayment(folioObj)}
                                        >Payment</button>

                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                
            </div>
        );
    };

    //when scroll , list api call and fetch more data
    const getNextData = () => {
        // folioHistoryListFn()
    }

    const makePayment = (row) => {
        // console.log("row", row)
        setPaymentViewDetails(row)
        setShowPaymentModal(true)
        setUserDetailsData({
            currency: row?.currency,
            due_amount: row?.due_amount,
            total_amount: row?.total_amount,
            booking_id: row?.booking_id,
            booking_master_id: row?.id,
            customer_id: row?.customer_id,
            BookingMasterBranchData: row?.BookingMasterBranchData
        });
        setBookingStatus(row?.book_status)
        setPaymentDetailsModalFlag(true);
        setSelectedFolioDetails(row)
        if (type == 'history')
            setPaymentHistoryShowFlag(true)
    }

    useEffect(() => {
        if (selectedFolioDetails) {
            // console.log("selectedFolioDetails===", selectedFolioDetails)
        }
    }, [selectedFolioDetails])

    //paymet modal close function
    const closePaymentModalFunction = () => {
        // setHotelBookingData([])
        // setSerachFlag(true)
        // setBookingRoomOffset(0)
        // setBookingRoomLimit(3)
        setShowPaymentModal(false)
        setPaymentHistoryShowFlag(false)
        setActionDone(false)
        setBookingStatus('')
        setPaymentViewDetails([])
        setSelectedFolioDetails([])
        setUserDetailsData({})
        setPaymentDetailsModalFlag(false)
    }

    //paymet modal close function
    const closePaymentModalFn = () => {
        // setHotelBookingData([])
        // setSerachFlag(true)
        // setBookingRoomOffset(0)
        // setBookingRoomLimit(3)
        setShowPaymentModal(false)
        setPaymentHistoryShowFlag(false)
        setActionDone(false)
        setBookingStatus('')
        setPaymentViewDetails([])
        setSelectedFolioDetails([])
        setUserDetailsData({})
        setPaymentDetailsModalFlag(false)
    }
    const skipPaymentFn = () => { }

    useEffect(() => {
        if (actionDone) {
            setShowPaymentModal(false);
            setActionDone(false)
            folioDetails(props.folioId)
        }
    }, [actionDone])
    
    return (
        <div className="booking-history-page">
            
            <div className="bookingHistoryContainer"
            >
                <div id="scrollableDiv" className='bookingHistoryContainerInner folioHistoryContainerInner' >
                    <InfiniteScroll
                        dataLength={viewDetailsData.length}
                        next={getNextData}
                        hasMore={hasMoreFolioList}
                        scrollableTarget="scrollableDiv"
                    >
                        <div className='booking-history-boxes'>
                            {hotelFolioDataUi()}
                        </div>
                    </InfiniteScroll>
                </div>
            </div>

            {showPaymentModal && <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={showPaymentModal}
                    onHide={paymentHistoryShowFlag ? closePaymentModalFunction : closePaymentModalFn}
                    title={bookingStatus == "Yet to confirm" ? <div>Payment <span className='yet_to_confirm'>(Yet to confirm)</span></div> : <div>Payment</div>}
                    className="modalcustomize mondimension paymentModalBX"
                    footer={false}
                    closeButton={true}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="BranchAddEditModalContent Error">
                                <PaymentViewModalContent
                                    bookingId={userDetailsData.booking_id}
                                    bookingMasterId={userDetailsData.booking_master_id}
                                    customerId={userDetailsData.customer_id}
                                    closePaymentModalFn={paymentHistoryShowFlag ? closePaymentModalFunction : closePaymentModalFn}
                                    skipPaymentFn={skipPaymentFn}
                                    bookingStatus={bookingStatus == "Confirmed" || bookingStatus == "Checked-In" || bookingStatus == "Yet to confirm" ? true : false}
                                    paymentHistoryShowFlag={paymentHistoryShowFlag ? true : false}
                                    OriginalbookingStatus={bookingStatus}
                                    paymentModalCallFrom="bookingHistory"
                                    bankInfoForPayments={userDetailsData}
                                    selectedFolioDetails={selectedFolioDetails}
                                    callFrom={"folio"}
                                    sourcingFolioId={sourcingBookingId}
                                    setActionDone={setActionDone}

                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>}
                        
        </div>
    )
}



const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials })(withNamespaces()(FolioDetails));

